module.exports = __webpack_public_path__ + "static/media/sunny_days.ba1b9ecf.svg";